import { useQuery } from '@tanstack/react-query';
import { currencyApi } from '../currencyApi';
import { QueryKey } from '@shared/config';
import { PaginateType } from '@shared/types';

export const useGetCurrency = () => {
  return useQuery({
    queryKey: [QueryKey.GET_CURRENCIES],
    queryFn: () =>
      currencyApi.getCurrencies({
        paginate: PaginateType.NONE,
        filter: {},
      }),
  });
};
